import { render, staticRenderFns } from "./PayersVindication.vue?vue&type=template&id=ad58c610&scoped=true"
import script from "./PayersVindication.vue?vue&type=script&lang=js"
export * from "./PayersVindication.vue?vue&type=script&lang=js"
import style0 from "./PayersVindication.vue?vue&type=style&index=0&id=ad58c610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad58c610",
  null
  
)

export default component.exports